import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as L from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { PopupComponent } from 'src/app/components/network-visibility/popup/popup.component';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-branch-map',
  templateUrl: './branch-map.component.html',
  styleUrls: ['./branch-map.component.css']
})
export class BranchMapComponent implements OnInit {
  private map!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];
  deviceType: any =[]
  deviceGroup:any = []
  usersList: any= []
  routeData: any = [];
  search = ""
  latitude: any = "";
  longitude: any = "";
  LatLng: any = [];
  lat: any = "";
  lng: any = "";
  routeid: any = "";
  Data: any = [];
  singleRoute: any = [];
  groupTypeList:any = [];
  group:any = "";
  type:any = "";
  routeDetails:any = [];
  marker2: any
  form: any | FormGroup
  cid: any
  isShowAddBranch: boolean = false
  branchList: any = []
  
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService,
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,private router: Router,
    private injector: Injector) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')

    this.form = this.fb.group({
      name: [''],
      latitude:[''],
      longitude:[''],
      address:[''],
      description:['']
    })  
    this.getBranch()
  }

  markerIcon = {
    icon: L.icon({
      iconSize: [25, 41],
      iconAnchor: [10, 41],
      popupAnchor: [2, -40],
      // specify the path here
      iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
      shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png"
    })
  };

  private initMap(): void {
    console.log("initMap")

    let centroid1: L.LatLngExpression[]= [];

    if(this.routeData.length != 0) {
      console.log("initMap 1")

      console.log(this.routeData)
      for(let i=0; i<this.routeData.length; i++){
        let obj:L.LatLngExpression = [
          Number(this.routeData[i].Lat),
          this.routeData[i].Lng
        ]
        centroid1.push(obj)
      }
      let loc = 0;
      let zoom = 10

      this.map = L.map('map', {
        center: centroid1[0],
        zoom: zoom
      });


      this.map.on("click", e => {
        // this.map.removeLayer(this.marker2);
        console.log(this.marker2); // get the coordinates
        if(this.marker2 != undefined){
          this.map.removeLayer(this.marker2);
        }
        console.log(e.latlng); // get the coordinates
        this.marker2 = new L.Marker(new L.LatLng(e.latlng.lat, e.latlng.lng),this.markerIcon);
        console.log(this.marker2); // get the coordinates

        // if (!this.map.hasLayer(marker2)) {
        //   this.map.removeLayer(marker2);
        // }
        this.map.addLayer(this.marker2);
        this.form.patchValue({
          latitude: e.latlng.lat,
          longitude: e.latlng.lng
        });
        // this.isShowAddBranch = true
        document.getElementById("add-branch-popup")?.click()

        // L.marker([e.latlng.lat, e.latlng.lng],this.markerIcon).addTo(this.map); // add the marker onclick
      });

      // this.map.on("dragend",e =>{
      //   console.log(e);

      // })
  
      const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        minZoom: 2,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
  
      L.Icon.Default.imagePath='https://www.iconpacks.net/icons/2/free-location-icon-2955-thumb.png';
  
      // create 5 random jitteries and add them to map
      
      for(let i = 0; i < centroid1.length; i++){
        let markerPopup: any = this.compilePopup(PopupComponent,(c:any) => {c.instance.customData = this.routeDetails[i]});
       let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup(
 
        markerPopup
       ).openPopup()
       loc.addTo(this.map)
      }
      tiles.addTo(this.map);
    }else{
      console.log("initMap 2")

      let loc = 0;
      let zoom = 5
      if(localStorage.getItem('loc') != '' && localStorage.getItem('loc') != null && localStorage.getItem('loc') != undefined){
        loc = Number(localStorage.getItem('loc'))
        zoom = 5
      }

      this.map = L.map('map', {
        center: [17.3850, 78.4867],
        zoom: zoom
      });
  
      const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        minZoom: 2,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
  
      tiles.addTo(this.map);

      this.map.on("click", e => {
        // this.map.removeLayer(this.marker2);
        console.log(this.marker2); // get the coordinates
        if(this.marker2 != undefined){
          this.map.removeLayer(this.marker2);
        }
        console.log(e.latlng); // get the coordinates
        this.marker2 = new L.Marker(new L.LatLng(e.latlng.lat, e.latlng.lng),this.markerIcon);
        console.log(this.marker2); // get the coordinates

        // if (!this.map.hasLayer(marker2)) {
        //   this.map.removeLayer(marker2);
        // }
        this.map.addLayer(this.marker2);
        this.form.patchValue({
          latitude: e.latlng.lat,
          longitude: e.latlng.lng
        });
        // this.isShowAddBranch = true
        document.getElementById("add-branch-popup")?.click()

        // L.marker([e.latlng.lat, e.latlng.lng],this.markerIcon).addTo(this.map); // add the marker onclick
      });

    }


  }

  defaultIcon = L.icon({
    iconUrl: 'assets/189707.png', // your path may vary ...
    iconSize: [30, 30],
    iconAnchor: [2, 2],
    popupAnchor: [0, -2]
  });

  // getAllRoute(){
  //   this.generic_service.getAllRoute().subscribe(
  //     (res:any)=> {
  //       // console.log(res)
  //       this.RouteData = res.response
  //       console.log(this.RouteData)
  //     },
  //     (err:any)=>{
  //       console.log(err)
  //     }
  //   )
  // }

  getObjectInfoById(id:any){

    this.map.remove();
    this.routeid = id
    this.generic_service.getObjectInfoById(id).subscribe(
      (response:any)=>{
        console.log(response)
        let sr:any = []
        this.singleRoute = []
        this.singleRoute.push(response.response)

        for(let data of this.singleRoute) {
          console.log(data)
          let sn = data.nameValue.filter((item: { key: string; }) => item.key == "Serial Number").map((item: any) =>{return item.value});
          let Lat = data.nameValue.filter((item: { key: string; }) => item.key == "Lat").map((item: any) =>{return item.value});
          let Lng = data.nameValue.filter((item: { key: string; }) => item.key == "Lng").map((item: any) =>{return item.value});
          if(Lat[0] != "" && Lat[0] != "null" && Lat[0] != "undefined" && Lat[0] != null && Lat[0] != undefined){
            let arr = {
              name: String(data.name),
              serialNumber: String(sn[0]),
              Lat: String(Lat[0]),
              Lng: String(Lng[0]),
            }
            sr.push(arr)
            this.routeDetails.push(data)
          }
        }

        let centroid1: L.LatLngExpression[]= [];

        if(sr.length != 0) {
    
          console.log(this.singleRoute)
          for(let i=0; i<sr.length; i++){
            let obj:L.LatLngExpression = [
              Number(sr[i].Lat),
              sr[i].Lng
            ]
            centroid1.push(obj)
          }
          let loc = 0;
          let zoom = 16
       
    
          this.map = L.map('map', {
            center: centroid1[0],
            zoom: zoom
          });
      
          const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            minZoom: 2,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          });
      
          L.Icon.Default.imagePath='https://www.iconpacks.net/icons/2/free-location-icon-2955-thumb.png';
      
          // create 5 random jitteries and add them to map
          
          for(let i = 0; i < centroid1.length; i++){
            let markerPopup: any = this.compilePopup(PopupComponent,(c:any) => {c.instance.customData = this.singleRoute[i]});
           let loc = L.marker(centroid1[i] as L.LatLngExpression,{icon: this.defaultIcon}).bindPopup(
     
            markerPopup
           ).openPopup()
           loc.addTo(this.map)
          }
          tiles.addTo(this.map);
        }
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  ngOnDestroy(){
    console.log("ngOnDestroy")
    this.map.remove();

  }

  getBranch(){
    this.generic_service.getBranch().subscribe(
      (res:any)=> {
        // this.map.remove();
        this.routeDetails = []
        this.routeData = []
        console.log(res)
        this.branchList = res.response
        for(let data of res.response) {
          console.log(data)

            let arr = {
              Lat: String(data.latitude),
              Lng: String(data.longitude),
            }
            this.routeData.push(arr)
            this.routeDetails.push(data)
          }
        console.log(this.routeData)
        console.log(this.routeDetails)

        this.initMap();

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

 


  compilePopup(component:any, onAttach:any): any {
    const compFactory: any = this.resolver.resolveComponentFactory(component);
    let compRef: any = compFactory.create(this.injector);

    // onAttach allows you to assign 
    if (onAttach)
      onAttach(compRef);

    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));
    
    let div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }
  
  remove(){
    this.map.removeLayer(this.marker2);
    this.isShowAddBranch = false
    this.form.reset()
    document.getElementById("closeModalButton")?.click()

  }

  addBranch(){
    let body = {

      "version": 0,
      "isActive": true,
      "description": String(this.form.get('description').value),
      "name": String(this.form.get('name').value),
      "latitude": String(this.form.get('latitude').value),
      "longitude": String(this.form.get('longitude').value),
      "address": String(this.form.get('address').value),
      "cid": this.cid,
    }

    console.log(body)
    this.generic_service.addBranch(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getBranch()
        this.form.reset()
        this.map.remove();
        this.isShowAddBranch = false
        this.toastr.success(response.message);
        document.getElementById("closeModalButton")?.click()

      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

}
